import { useMutation, useQuery } from "@tanstack/react-query";

import type { AllEInput, AllEOutput } from "../../functions/_lib/alle-check/types";
import type { HybridSavingsSummary } from "../../functions/_lib/savings";

export type BestChoice = "all_electric" | "hybrid";

export interface Headline {
  best_choice: BestChoice;
}

export interface CheckResponse {
  id: string;
  result: AllEOutput;
  /** Hybrid (Besparingscheck) savings. Null on the BENG1 route. */
  hybrid?: HybridSavingsSummary | null;
  headline?: Headline;
}

interface SubmissionResponse extends CheckResponse {
  created_at: string;
  source: string;
  installer_id: string | null;
  input: AllEInput;
  overall: string;
  meerwerk_tier: string;
}

export function useAlleCheckMutation(lang: "nl" | "en" = "nl") {
  return useMutation<CheckResponse, Error, AllEInput>({
    mutationFn: async (input) => {
      const res = await fetch(`/api/v1/alle-check/check?lang=${lang}`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(input),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `HTTP ${res.status}`);
      }
      return res.json();
    },
  });
}

export function useAlleCheckSubmission(id: string | undefined) {
  return useQuery<SubmissionResponse, Error>({
    queryKey: ["alle-check-submission", id],
    enabled: Boolean(id),
    queryFn: async () => {
      const res = await fetch(`/api/v1/alle-check/submissions/${id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    },
  });
}
